import React from "react";
import { useRouteMatch } from "react-router-dom";
import { ListItem } from "../../common/components/ListItem";
import { NoRecords } from "../../common/components/NoRecords";
import { Loader } from "semantic-ui-react";
import { ErrorSegment } from "../../common/components/ErrorSegment";
import { PaginationButtons } from "../../common/components/PaginationButtons";
import { PositionTable } from "./PositionTable";

const PositionListItems = ({ positions }) => {
  let { url } = useRouteMatch();

  if (positions.length === 0) {
    return (
      <NoRecords iconName="briefcase" message="Não encontramos nenhum cargo!" />
    );
  }

  return positions.map((position) => (
    <ListItem
      key={position.id}
      code={position.code}
      item={position.name}
      item_subtitle={position.category}
      employee_count={position.employee_count}
      active_since={position.current_record.timespan.lower.fromNow(true)}
      base_url={`${url}/${position.id}`}
    />
  ));
};

export const PositionList = ({ positionData }) => {
  if (positionData.isPending) return <Loader active />;
  if (positionData.error)
    return <ErrorSegment message={positionData.error.message} />;
  if (positionData.data) {
    return (
      <>
        <PositionTable
          positions={positionData.data.results}
          reload={positionData.refetch}
        />
        <PaginationButtons
          previous={positionData.data?.previous}
          next={positionData.data?.next}
          onPrevious={positionData.handlePrevious}
          onNext={positionData.handleNext}
        />
      </>
    );
  }

  return null;
};
